export default __webpack_public_path__ + "static/media/moon.b6cc4a7a.jpg";